import { Node, mergeAttributes } from '@tiptap/core';

/**
 * A manual page break for the PDF. Serialized as
 * <p style="page-break-before: always"></p>, which dompdf honours and the
 * server sanitizer allows; shown in the editor as a dashed divider.
 */
export const PageBreakNode = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,

  parseHTML() {
    return [{ tag: 'p[style*="page-break-before"]' }, { tag: 'div[data-page-break]' }];
  },

  renderHTML() {
    return ['p', mergeAttributes({ style: 'page-break-before: always', class: 'page-break', 'data-page-break': 'true' })];
  },

  addCommands() {
    return {
      setPageBreak: () => ({ commands }) => commands.insertContent({ type: this.name }),
    };
  },
});

export default PageBreakNode;
